<template>
  <!-- <SuspenseWithError> -->
    <router-view v-slot="{ Component }">
      <transition name="fade-slide" mode="out-in" appear>
        <component :is="Component" />
      </transition>
    </router-view>
  <!-- </SuspenseWithError> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SuspenseWithError from '@/components/SuspenseWithError.vue';

export default defineComponent({
  name: 'RouterTransition',
  components: { SuspenseWithError },
  props: {
    notNeedKey: {
      type: Boolean,
      default: false
    },
    animate: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {};
  }
});
</script>
